
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Spinner } from '../../components';
import queryString from 'query-string';


const Waitlist = (props) => {

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let params = queryString.parse(props.location.search);
        if (params.email) {
            axios.put(`/api/release/unsub-waitlist/${params.email}`).then(res => {
                setIsLoading(false);
            })
                .catch(err => {
                    console.error(err);
                });
        }
    });

    if (isLoading) return (
        <Spinner></Spinner>
    );

    return (
        <p>Unsubscribed</p>
    )


}

export default Waitlist;